<template>
  <div class=" main-container d-flex flex-column align-center">
    <!-- Text on top -->
    <div class="mb-2 text-h6">
      {{ text }}
    </div>

    <!-- Circular progress with icon in the center -->
    <div class="position-relative">
      <v-progress-circular
        :model-value="percentage"
        size="100"
        width="10"
        color="primary"
      ></v-progress-circular>

      <!-- Icon in center -->
      <v-icon
        class="center-icon"
        :color="iconColor"
        size="40"
      >
        {{ icon }}
      </v-icon>
    </div>

    <!-- Value / MaxValue below the circle -->
    <div class="mt-2 value-text">
      {{ formatValue(value) }} / {{ formatValue(maxValue) }}
    </div>
    <div v-if="isError" class=" error mt-2 value-text">
      Limit Exceeded
    </div>
    <div v-if="isWarn"  class=" warn mt-2 value-text">
      Capacity Warning
    </div>
   
  </div>
</template>

<script setup>
import { computed, ref } from "vue"

const props = defineProps({
  value: { type: Number, default: 0 },
  maxValue: { type: Number, default: 100 },
  text: { type: String, default: "" },
  icon: { type: String, default: "mdi-check" },
  iconColor: { type: String, default: "primary" },
  type: { type: String, default: "" },
})

var isWarn=ref(false);
var isError=ref(false);

function formatValue(v) {

      if (props.type=="") 
      {
        const units = ['', 'K', 'M', 'B', 'T'];
        if (v === 0) return '0';

        const i = Math.floor(Math.log(v) / Math.log(1000));
        const size = v / 1000 ** i;

        return `${size} ${units[i]}`;
      }

      if (props.type=="bytes")
      {
        const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (v === 0) return '0 Bytes';

        const i = Math.floor(Math.log(v) / Math.log(1000));
        const size = v / 1000 ** i;

        return `${size.toFixed(2)} ${units[i]}`;
      }

      if (props.type=="$") 
      {
        return `$${v.toFixed(2)}`;
      }

      
    }


const percentage = computed(() => {


  if (props.value>(props.maxValue*.7) && props.value<=(props.maxValue))  {
      isWarn=true;
  }
    
  if (props.value>(props.maxValue))  {
    isError=true;
 }
  

  return props.maxValue > 0 ? (props.value / props.maxValue) * 100 : 0
})
</script>

<style scoped>
.main-container {
  margin: 30px;
  min-width: 140px;
}

.error {
  background-color:red;
  color:rgb(255, 251, 142);
  padding-left:12px;
  padding-right:12px;
  border-radius: 6px;
   border: solid 1px rgb(193, 193, 193);
}

.warn {
  background-color:rgb(229, 216, 140);
  color:rgb(78, 109, 128);
  padding-left:12px;
  padding-right:12px;
  border-radius: 6px;
  border: solid 1px rgb(193, 193, 193);
}

.center-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.value-text {
  font-size: 0.9rem;
  font-weight: 500;
}
</style>
